import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { AuthGuard } from '@auth0/auth0-angular';

import { NotFoundPageComponent } from './pages/not-found/not-found-page.component';
import { ManageZonesPageComponent } from './pages/manage-zones/manage-zones-page.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'manage-zones',
  },
  {
    path: 'manage-zones',
    component: ManageZonesPageComponent,
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
